<footer
  [class]="variant() === 'layout'
    ? 'py-3 sm:py-4 px-4 sm:px-6 text-center text-xs text-content-muted border-t border-border-subtle/50 mt-auto w-full min-w-0'
    : 'py-3 px-4 text-center text-xs text-content-muted w-full min-w-0'"
>
  <div class="flex items-center justify-center gap-1.5 flex-wrap">
    <span>&copy; {{ currentYear() }}</span>
    <span class="font-semibold text-content">DevAssociate</span>
    <span class="text-content-subtle">&bull;</span>
    <span>Tous droits r&eacute;serv&eacute;s.</span>
  </div>
</footer>
